import React from "react";
import logo from "../Assets/logo.png";

export default function PlaylistMosaic({ thumbnails = [] }) {
  // Fallback to logo if no thumbnails
  if (!thumbnails || thumbnails.length === 0) {
    return (
      <img
        src={logo}
        alt="Playlist"
        className="absolute inset-0 w-full h-full object-cover"
      />
    );
  }

  // Single image
  if (thumbnails.length === 1) {
    return (
      <img
        src={thumbnails[0]}
        alt="Playlist thumbnail"
        className="absolute inset-0 w-full h-full object-cover"
      />
    );
  }

  // 2-4 images: 2x2 grid
  if (thumbnails.length <= 4) {
    const gridImages = thumbnails.slice(0, 4);
    return (
      <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-0.5">
        {gridImages.map((url, idx) => (
          <div key={idx} className="relative w-full h-full bg-neutral-700">
            <img
              src={url}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
    );
  }

  // 5-9 images: 3x3 grid
  const gridImages = thumbnails.slice(0, 9);
  return (
    <div className="absolute inset-0 grid grid-cols-3 grid-rows-3 gap-0.5">
      {gridImages.map((url, idx) => (
        <div key={idx} className="relative w-full h-full bg-neutral-700">
          <img
            src={url}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  );
}
